"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferToSha1 = void 0;
const crypto = require("crypto");
const types_1 = require("./types");
const HASH_ENCODING = "hex";
function bufferToSha1(buffer) {
    const hash = crypto.createHash(types_1.HashAlgorithm.Sha1);
    hash.setEncoding(HASH_ENCODING);
    hash.update(buffer);
    hash.end();
    return hash.read().toString(HASH_ENCODING);
}
exports.bufferToSha1 = bufferToSha1;
//# sourceMappingURL=buffer-utils.js.map